import "@app/App.css";
import { Popover, PopoverContent, PopoverTrigger } from "@comps/ui/popover";
import Field from "@dto/fields";
import { TW_FieldMenuButtonNotDisabled, TW_FieldMenuPopoverContent } from "@utils/twClasses";
import { EllipsisVertical } from "lucide-react";
import { useState } from "react";
import { useDataStore } from "src/store";
import FieldMenuDeleteItem from "./FieldMenuDeleteItem";
import FieldMenuDuplicateItem from "./FieldMenuDuplicateItem";
import FieldMenuUpdateItem from "./FieldMenuUpdateItem";

interface ConfigFieldMenuButtonProps {
  field: Field;
  isCellHovered: boolean;
  visible: boolean;
}

function ConfigFieldMenuButton({ field, isCellHovered, visible }: ConfigFieldMenuButtonProps) {

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const fetchData = useDataStore((state) => state.fetchData);
  const rowActionsEnabled = useDataStore(state => state.rowActionsEnabled);

  const deleteFieldFromState = () => {
    fetchData();
  }

  const updateFieldFromState = (_: Field) => {
    fetchData();
  }

  const deleteField = () => {
    deleteFieldFromState();
    setIsPopoverOpen(false);
  }

  const updateField = (updatedField: Field ) => {
    updateFieldFromState(updatedField);
    setIsPopoverOpen(false);
  }

  const closeMenu = () => {
    setIsPopoverOpen(false);
  }

  const positionStyle = (!visible) ? {
    position: "absolute",
    right: "0.5rem",
    minWidth: "1px",
    minHeight: "1px",
    width: "1px",
  } as React.CSSProperties : {
    position: "inherit",
    minWidth: "1px",
    minHeight: "1px",
    width: "1px",
  } as React.CSSProperties;

  const isDisabled = !rowActionsEnabled;
  let opacity = "opacity-100";
  if (!visible && !isCellHovered) {
    opacity = "opacity-0";
  } else if (isDisabled) {
    opacity = "opacity-50";
  } else {
    opacity = "opacity-100";
  }
  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen} >
      <PopoverTrigger disabled={isDisabled} className={"ml-2 " + TW_FieldMenuButtonNotDisabled + (isDisabled ? " cursor-not-allowed" : " cursor-default") + opacity} style={positionStyle}>
          <EllipsisVertical className={" bg-gray-100 " + opacity}/>
      </PopoverTrigger>
      <PopoverContent className={TW_FieldMenuPopoverContent}>
        <ul>
          <li><FieldMenuUpdateItem field={field} onFieldUpdate={updateField} closeMenu={closeMenu} /></li>
          <li><FieldMenuDuplicateItem field={field} onFieldUpdate={updateField} closeMenu={closeMenu} /></li>
          <li><FieldMenuDeleteItem field={field} onFieldDelete={deleteField} closeMenu={closeMenu} /></li>
        </ul>
      </PopoverContent>
    </Popover>
  )
}

export default ConfigFieldMenuButton;
